module.exports = __webpack_public_path__ + "static/media/flood-step-icon-fc.7a2488ad.svg";